import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';

export class SelectionFrontWalls extends SelectionBase {
    protected id: string = 'front-walls-select';

    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: ProjectSettingsStore.getState().frontWalls,
            enabled: true,
            visible: true
        });
    };

    protected getLabel(): string {
        return t('Front walls');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {
                value: 'invisible',
                name: t('invisible'),
                className: 'egr-select-option-noicon',
                callback: () => ProjectSettingsActions.setFrontWalls('invisible')
            },
            {
                value: 'visible',
                name: t('visible'),
                className: 'egr-select-option-noicon',
                callback: () => ProjectSettingsActions.setFrontWalls('visible')
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionFrontWalls.tsx